import React, { Fragment } from 'react'
import estilos from './MarcasMezcalComponent.module.css'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import ModalHistorialCambiosComponent from '../ModalHistorialCambiosComponent';

function MarcasBebidaMezcalComponent(props) {

    const [marca, setMarca] = React.useState(props?.data?.marca?.toUpperCase())
    const [numeroderegistroimpi, setNumeroRegistro] = React.useState(props?.data?.numeroderegistroimpi?.toUpperCase())
    const [idtipomarca, setTipoMarca] = React.useState(props?.data?.idtipomarca == 1 ? 'MIXTA' : props?.data?.idtipomarca == 2 ? 'NOMINATIVA' : props?.data?.idtipomarca == 3 ? 'TRIDIMENCIONAL' : '')
    const [productor, setProductor] = React.useState(props?.data?.productor?.toUpperCase())
    const [maquilador, setMaquilador] = React.useState(props?.data?.maquilador?.toUpperCase())

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(props?.data?.marcasproductoconmezcalclientehistorial);
    const handleModalHistorial = () => {
        setDataHistorial(props?.data?.marcasproductoconmezcalclientehistorial)
        setOpenModalHistorial(true)
    }

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-8 container2">
                        <div className={`${estilos.lista}`}>
                            <ol className={`${estilos.ol}`}>
                                <li className={`${estilos.li}`}>
                                    <div className={`${estilos.circulo}`}>
                                        <b style={{ width: '100%', textAlign: 'center' }}>{Number(props?.index) + 1}</b>
                                    </div>
                                    <div className={`${estilos.card} ${estilos.cardHtml}`} style={{ marginTop: '-10%' }}>
                                        <div className={props?.data?.isbaja ? `${estilos.cardHeaderBaja}` : `${estilos.cardHeader}`}>
                                            <h4 style={{ margin: 0 }}>MARCA: {marca} </h4>
                                        </div>
                                        <div className={`${estilos.cardBody} row`}>
                                            <div className='row' style={{ margin: 0, padding: 0 }}>
                                                {props?.data?.isbaja == false &&
                                                    <div style={{ display: 'flex', justifyContent: 'end' }} >
                                                        <Tooltip title="Ver historial de cambios">
                                                            <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                                                <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                }
                                                <div className={props?.data?.isbaja ? "col-md-6 mt-3 ps-5 text-start" : "col-md-6 mt-0 ps-5 text-start"}><label><b>Número de registro: <br /> </b> {numeroderegistroimpi} </label> </div>
                                                <div className={props?.data?.isbaja ? "col-md-6 mt-3 ps-5 text-start" : "col-md-6 mt-0 ps-5 text-start"}><label><b>Tipo de marca: <br /> </b> {idtipomarca} </label> </div>
                                                <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Titularidad: <br /> </b>
                                                    {(props.data.idtitularidaddemarca == 1 ? 'Marca propia' :
                                                        props.data.idtitularidaddemarca == 2 ? 'Marca propia en trámite' :
                                                            props.data.idtitularidaddemarca == 3 ? 'Marca de licencia de uso autorizado' :
                                                                props.data.idtitularidaddemarca == 4 ? 'Marca cesión de derechos autorizada' :
                                                                    props.data.idtitularidaddemarca == 5 ? 'Marca de licencia de uso en trámite' :
                                                                        props.data.idtitularidaddemarca == 6 ? 'Marca cesión de derechos en trámite' :
                                                                            '')?.toUpperCase()} </label>
                                                </div>
                                                {props?.data?.productor != '' && props?.data?.productor != null && props?.data?.productor != undefined &&
                                                    <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Productor: <br /> </b> {productor} </label> </div>
                                                }
                                                {props?.data?.maquilador != '' && props?.data?.maquilador != null && props?.data?.maquilador != undefined &&
                                                    <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Maquilador: <br /> </b> {maquilador} </label> </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={"Marca de Bebida con Mezcal"} />}
            </ThemeProvider>
        </Fragment >
    )
}

export default MarcasBebidaMezcalComponent